import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["row"]
  static values = { selectId: String }

  connect() {
    this.selectElement = document.getElementById(this.selectIdValue)
    if (this.selectElement) {
      this.boundFilter = this.filter.bind(this)
      this.selectElement.addEventListener("change", this.boundFilter)
      this.filter()
    }
  }

  disconnect() {
    if (this.selectElement) {
      this.selectElement.removeEventListener("change", this.boundFilter)
    }
  }

  filter() {
    const selected = new Set(Array.from(this.selectElement.selectedOptions).map((opt) => opt.value))

    if (selected.size === 0) {
      this.element.classList.add("hidden")
      return
    }

    this.element.classList.remove("hidden")

    this.rowTargets.forEach((row) => {
      row.classList.toggle("hidden", !selected.has(row.dataset.employeeId))
    })
  }
}
